import React from "react";
import { Sparkles } from "lucide-react";

const SOURCE_LABEL = {
  anime: "from your worlds",
  dream: "from your dream",
  past_win: "from your past",
};

export default function AffirmationCard({ text, source, size = "md", testid = "affirmation-card" }) {
  if (!text) return null;
  const sizes = {
    sm: "text-base sm:text-lg",
    md: "text-xl sm:text-2xl",
    lg: "text-2xl sm:text-3xl md:text-4xl",
  };
  return (
    <div
      className="relative rounded-3xl px-6 sm:px-8 py-6 sm:py-8 fade-up"
      style={{
        background:
          "linear-gradient(140deg, color-mix(in oklab, var(--primary-soft) 55%, var(--surface)), var(--surface))",
        border: "1px solid var(--border)",
        boxShadow: "0 20px 40px -24px rgba(60, 40, 50, 0.2)",
      }}
      data-testid={testid}
    >
      <div className="flex items-center gap-2 mb-3">
        <Sparkles size={14} strokeWidth={1.5} style={{ color: "var(--primary)" }} />
        <span className="eyebrow">{SOURCE_LABEL[source] || "for you"}</span>
      </div>
      <blockquote
        className={`font-display italic leading-snug ${sizes[size]}`}
        style={{ color: "var(--text)" }}
        data-testid="affirmation-text"
      >
        {text}
      </blockquote>
    </div>
  );
}
